import { prop, propOr } from 'ramda';
import { createSelector } from 'reselect';

import { EMPTY_VALUES } from 'constants/general';

import { NAME } from './constants';

const getRoot = prop(NAME);

export const getUnpaidFirstPaymentList = createSelector(getRoot, propOr(EMPTY_VALUES.OBJECT, 'unpaidFirstPaymentList'));
export const getUnpaidFirstPaymentCountByProductDomain = createSelector(
	(state, productDomain) => productDomain,
	getUnpaidFirstPaymentList,
	(productDomain, unpaidFirstPaymentList) => {
		return propOr(0, productDomain)(unpaidFirstPaymentList);
	},
);
export const getLeadsInProgress = createSelector(getRoot, propOr(EMPTY_VALUES.ARRAY, 'leadsInProgress'));
export const getCampaignsNearingTheEnd = createSelector(getRoot, propOr(EMPTY_VALUES.ARRAY, 'campaignsNearingTheEnd'));
export const getEscalationBasic = createSelector(getRoot, propOr(EMPTY_VALUES.ARRAY, 'escalationBasic'));
export const getEscalationSummary = createSelector(getRoot, propOr(EMPTY_VALUES.ARRAY, 'escalationSummary'));
export const getCampaignsNearingTheEndManager = createSelector(
	getRoot,
	propOr(EMPTY_VALUES.ARRAY, 'campaignsNearingTheEndManager'),
);
export const getCampaignsNearingTheEndContactRelease = createSelector(
	getRoot,
	propOr(EMPTY_VALUES.ARRAY, 'campaignsNearingTheEndContactRelease'),
);
export const getLeadsToProcess = createSelector(getRoot, propOr(EMPTY_VALUES.ARRAY, 'leadsToProcess'));
